import {
  NullableRoomAnyId,
  RoomAnyId,
  RtmpDestinationEntityId,
  RtmpDestinationKey,
  RtmpDestinationUrl,
  RtmpDestinationV2Entity
} from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const loadRtmpDestinations = createAction(
  "[Destinations/API] Load RTMP Destinations"
);
export const loadRtmpDestinationsSuccess = createAction(
  "[Destinations/API] Load RTMP Destinations Success",
  props<{ destinations: RtmpDestinationV2Entity[] }>()
);
export const loadRtmpDestinationsFailure = createAction(
  "[Destinations/API] Load RTMP Destinations Failure",
  props<{ error: string }>()
);

export const addRtmpDestination = createAction(
  "[Destinations/API] Add RTMP Destination",
  props<{
    url: RtmpDestinationUrl;
    key: RtmpDestinationKey;
    roomId?: RoomAnyId;
  }>()
);
export const addRtmpDestinationSuccess = createAction(
  "[Destinations/API] Add RTMP Destination Success",
  props<{ destination: RtmpDestinationV2Entity }>()
);
export const addRtmpDestinationFailure = createAction(
  "[Destinations/API] Add RTMP Destination Failure",
  props<{ error: string }>()
);

export const updateRtmpDestination = createAction(
  "[Destinations/API] Update RTMP Destination",
  props<{
    id: RtmpDestinationEntityId;
    url?: RtmpDestinationUrl;
    key?: RtmpDestinationKey;
    roomId?: NullableRoomAnyId;
  }>()
);
export const updateRtmpDestinationSuccess = createAction(
  "[Destinations/API] Update RTMP Destination Success",
  props<{ destination: RtmpDestinationV2Entity }>()
);
export const updateRtmpDestinationFailure = createAction(
  "[Destinations/API] Update RTMP Destination Failure",
  props<{ error: string }>()
);
export const updateRtmpDestinationCancel = createAction(
  "[Destinations/API] Update RTMP Destination Cancel"
);

export const deleteRtmpDestination = createAction(
  "[Destinations/API] Delete RTMP Destination",
  props<{ id: RtmpDestinationEntityId }>()
);
export const deleteRtmpDestinationSuccess = createAction(
  "[Destinations/API] Delete RTMP Destination Success",
  props<{ id: RtmpDestinationEntityId }>()
);
export const deleteRtmpDestinationFailure = createAction(
  "[Destinations/API] Delete RTMP Destination Failure",
  props<{ error: string }>()
);
export const deleteRtmpDestinationCancel = createAction(
  "[Destinations/API] Delete RTMP Destination Cancel"
);
